import { render, staticRenderFns } from "./MyCompanyBusinessUnitPricingArticleRow.vue?vue&type=template&id=5b3943dd&scoped=true&"
import script from "./MyCompanyBusinessUnitPricingArticleRow.vue?vue&type=script&lang=js&"
export * from "./MyCompanyBusinessUnitPricingArticleRow.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyBusinessUnitPricingArticleRow.vue?vue&type=style&index=0&id=5b3943dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3943dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VProgressCircular,VTextField})
